import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Redirect = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const to = searchParams.get('to');

  useEffect(() => {
    if (!to) {
      navigate('/');
      return;
    }

    try {
      const decodedUrl = decodeURIComponent(to);
      const finalUrl = decodedUrl.startsWith('http') ? decodedUrl : `https://${decodedUrl}`;
      window.location.replace(finalUrl);
    } catch (error) {
      console.error('Error during redirect:', error);
      navigate('/');
    }
  }, [to, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <Helmet>
        <title>Redirigiendo... | Directorio Médico</title>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>
      
      <div className="text-center">
        <h1 className="text-2xl font-semibold mb-4">Redirigiendo...</h1>
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
        {to && (
          <p className="mt-4 text-gray-600">
            Redirigiendo a: {decodeURIComponent(to)}
          </p>
        )}
      </div>
    </div>
  );
};

export default Redirect; 